import { Translate } from '../../shared/LanguageService';
import { NavItem, Dropdown, Button } from 'react-bootstrap';
import * as React from 'react';
import * as Features from '../../shared/Features';

interface IDownloadButtonWithDropDown {
    order: any;
    secondaryStorageExists: boolean;
    downloadEditedImages: (order: number, forcePrimaryStorage?: boolean) => void;
}

export class DownloadButtonWithDropDown extends React.Component<IDownloadButtonWithDropDown, any> {
    constructor(props: IDownloadButtonWithDropDown, context: any) {
        super(props, context);
        this.state = { showModal: false };
    }

    render() {
        const buttonDivLeftStyle = {
            width: 'max-content',
            position: 'relative',
            float: 'left'
        };
        return (
            <>
                {this.props.secondaryStorageExists && (
                    <div style={buttonDivLeftStyle}>
                        <Button
                            onClick={() => {
                                this.props.downloadEditedImages(this.props.order.orderId);
                            }}
                        >
                            {Translate('unedited-orders/table/button/download')}{' '}
                        </Button>
                        <Dropdown id="download-dropdown" pullRight={true}>
                            <Dropdown.Toggle></Dropdown.Toggle>
                            <Dropdown.Menu>
                                {this.props.secondaryStorageExists && (
                                    <NavItem
                                        onClick={() => {
                                            this.props.downloadEditedImages(
                                                this.props.order.orderId,
                                                true
                                            );
                                        }}
                                    >
                                        {Translate('unedited-orders/table/button/download-primary')}{' '}
                                    </NavItem>
                                )}
                                {this.props.secondaryStorageExists && (
                                    <NavItem
                                        onClick={() => {
                                            this.props.downloadEditedImages(
                                                this.props.order.orderId
                                            );
                                        }}
                                    >
                                        {Translate(
                                            'unedited-orders/table/button/download-secondary'
                                        )}{' '}
                                    </NavItem>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
                {!this.props.secondaryStorageExists && (
                    <Button
                        onClick={() => {
                            this.props.downloadEditedImages(this.props.order.orderId);
                        }}
                    >
                        {Translate('unedited-orders/table/button/download')}{' '}
                    </Button>
                )}
            </>
        );
    }
}
